import { STATUS_STYLES } from "@/lib/constants";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const Badge = ({ value, map, style, testid }) => (
  <span
    data-testid={testid}
    className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium ${STATUS_STYLES[style || value] || STATUS_STYLES.annule}`}
  >
    {map ? map[value] || value : value}
  </span>
);

export const Field = ({ label, children, className = "" }) => (
  <div className={`space-y-1.5 ${className}`}>
    <Label className="text-xs uppercase tracking-wider text-slate-400">{label}</Label>
    {children}
  </div>
);

const NONE = "__none";

export const SelectField = ({ value, onChange, options, testid, placeholder, allowNone, className = "" }) => {
  const entries = Array.isArray(options) ? options : Object.entries(options);
  return (
    <Select value={value || (allowNone ? NONE : undefined)} onValueChange={(v) => onChange(v === NONE ? null : v)}>
      <SelectTrigger data-testid={testid} className={className}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="bg-[#0F1F3D] border-cyan-400/20">
        {allowNone && <SelectItem value={NONE}>{allowNone}</SelectItem>}
        {entries.map(([k, label]) => (
          <SelectItem key={k} value={k} data-testid={`${testid}-option-${k}`}>
            {label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between dt-rise">
    <div>
      <p className="font-mono-dt text-xs uppercase tracking-[0.25em] text-cyan-300/80">DTech42</p>
      <h1 className="text-3xl font-bold tracking-tight text-white lg:text-4xl">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-slate-400">{subtitle}</p>}
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

export const Empty = ({ children, testid }) => (
  <div data-testid={testid} className="rounded-lg border border-dashed border-cyan-400/20 p-6 text-center text-sm text-slate-400">
    {children}
  </div>
);

export const ConfirmDelete = ({ open, onOpenChange, onConfirm, label, description }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent className="bg-[#0F1F3D] border-cyan-400/20">
      <AlertDialogHeader>
        <AlertDialogTitle>Supprimer {label} ?</AlertDialogTitle>
        <AlertDialogDescription>{description || "Cette action est définitive."}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="confirm-delete-cancel">Annuler</AlertDialogCancel>
        <AlertDialogAction data-testid="confirm-delete-button" className="bg-red-600 hover:bg-red-500" onClick={onConfirm}>
          Supprimer
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export const FormDialogShell = ({ title, children }) => (
  <>
    <h2 className="text-xl font-semibold text-white">{title}</h2>
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">{children}</div>
  </>
);
